// Author liang gang qiang
// Date 2021-11-22 17:18:29

class MintalMesPrdProductionResult {
constructor({
        id = null,
        prdShiftPlanId = '',
        mstFurnaceId = '',
        actualOutput = '',
        remark = ''}
= {}) {
    this.id = id;
    this.prdShiftPlanId = prdShiftPlanId;
    this.mstFurnaceId = mstFurnaceId;
    this.actualOutput = actualOutput;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesPrdProductionResult();
}

const pelletizingVoConfigs = [
        {
        key: 'shiftPlanCode',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.grid.shiftPlanCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'planDay',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.grid.planDay',
        sortable: true,
        form: {
        type: 'datepicker'
        }
        },
        {
        key: 'locationName',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.grid.locationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'materialName',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.grid.materialName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'shiftName',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.grid.shiftName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'shiftStartTime',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.grid.shiftStartTime',
        sortable: true,
        form: {
        type: 'hour_minute'
        }
        },
        {
        key: 'shiftEndTime',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.grid.shiftEndTime',
        sortable: true,
        form: {
        type: 'hour_minute'
        }
        },
        {
        key: 'planOutput',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.grid.planOutput',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'actualOutput',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.grid.actualOutput',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'finishRate',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.grid.finishRate',
        sortable: true,
        form: {
        type: 'input'
        }
        }
    ]
    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'shiftPlanCode',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.grid.shiftPlanCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'planDay',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.grid.planDay',
        sortable: true,
        form: {
        type: 'datepicker'
        }
        },
        {
        key: 'locationName',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.grid.locationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'materialName',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.grid.materialName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'shiftName',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.grid.shiftName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'shiftStartTime',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.grid.shiftStartTime',
        sortable: true,
        form: {
        type: 'hour_minute'
        }
        },
        {
        key: 'shiftEndTime',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.grid.shiftEndTime',
        sortable: true,
        form: {
        type: 'hour_minute'
        }
        },
        {
        key: 'furnaceName',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.grid.furnaceName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'planOutput',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.grid.planOutput',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'actualOutput',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.grid.actualOutput',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'finishRate',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.grid.finishRate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}
const smeltingVoConfigs = [
        {
        key: 'shiftPlanCode',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.grid.shiftPlanCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'planDay',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.grid.planDay',
        sortable: true,
        form: {
        type: 'datepicker'
        }
        },
        {
        key: 'locationName',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.grid.locationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'materialName',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.grid.materialName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'shiftName',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.grid.shiftName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'shiftStartTime',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.grid.shiftStartTime',
        sortable: true,
        form: {
        type: 'hour_minute'
        }
        },
        {
        key: 'shiftEndTime',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.grid.shiftEndTime',
        sortable: true,
        form: {
        type: 'hour_minute'
        }
        },
        {
        key: 'furnaceName',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.grid.furnaceName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'planOutput',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.grid.planOutput',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'actualOutput',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.grid.actualOutput',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'finishRate',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.grid.finishRate',
        sortable: true,
        form: {
        type: 'input'
        }
        }
    ]

const filter = {
    idFilter : '',
    idListFilter : [],
    prdShiftPlanIdFilter : '',
    mstFurnaceIdFilter : '',
    planOutputFilter : '',
    actualOutputFilter : '',
    locationCodeFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const pelletizingFilterConfigs = [
        {
        key: 'prdShiftPlanIdFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.filter.prdShiftPlanId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdShiftPlan'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'planOutputFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.filter.planOutput',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'actualOutputFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.filter.actualOutput',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
];
const filterConfigs = [
        {
        key: 'prdShiftPlanIdFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.filter.prdShiftPlanId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdShiftPlan'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'mstFurnaceIdFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.filter.mstFurnaceId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesMstFurnace'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'planOutputFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.filter.planOutput',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'actualOutputFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.filter.actualOutput',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
];
const smeltingFilterConfigs = [
        {
        key: 'prdShiftPlanIdFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.filter.prdShiftPlanId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdShiftPlan'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'mstFurnaceIdFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.filter.mstFurnaceId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesMstFurnace'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'planOutputFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.filter.planOutput',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'actualOutputFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.filter.actualOutput',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
];


    const pelletizingEntityConfigs = [
        {
        key: 'prdShiftPlanId',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.entity.prdShiftPlanId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdShiftPlan'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'actualOutput',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.entity.actualOutput',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
]
    const entityFormConfigs = [
        {
        key: 'prdShiftPlanId',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.entity.prdShiftPlanId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdShiftPlan'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'mstFurnaceId',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.entity.mstFurnaceId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesMstFurnace'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'actualOutput',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.entity.actualOutput',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]
    const smeltingEntityConfigs = [
        {
        key: 'prdShiftPlanId',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.entity.prdShiftPlanId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdShiftPlan'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'mstFurnaceId',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.entity.mstFurnaceId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesMstFurnace'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'actualOutput',
        label: 'label.mintal.prd.mintalMesPrdProductionResult.entity.actualOutput',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
]

export {MintalMesPrdProductionResult, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, pelletizingFilterConfigs, filterConfigs, smeltingFilterConfigs
, pelletizingEntityConfigs, smeltingEntityConfigs
, pelletizingVoConfigs, smeltingVoConfigs
}
